import http from '@/plugins/axios/axios';

export default class EmpresaService {

    listarEstados() {        
        return http.get('/api/empresa/listar-estados');
    }

    listarCidades(idEstado) {       
        return http.get('/api/empresa/listar-cidades/'+idEstado);
    }

    listar() {       
        return http.get('/api/adm/empresa/listar');
    } 

    buscar(requisicao) {       
        return http.post('/api/adm/empresa/buscar', requisicao);
    }

    salvar(requisicao) {       
        return http.post('/api/adm/empresa/salvar', requisicao);
    }

    trocarPlano(requisicao) {
        return http.post('/api/adm/empresa/trocar-plano', requisicao);
    }
    
    editarStatus(requisicao) {
        return http.post('/api/adm/empresa/editar-status', requisicao);
    }

    buscarClientes(requisicao) { 
        return http.post('/api/adm/empresa/buscar-clientes-status', requisicao);
    }
    
}